import { render } from "./KTdatatableheaders.vue?vue&type=template&id=7295380a&ts=true"
import script from "./KTdatatableheaders.vue?vue&type=script&lang=ts"
export * from "./KTdatatableheaders.vue?vue&type=script&lang=ts"

import "./KTdatatableheaders.vue?vue&type=style&index=0&id=7295380a&lang=scss"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__